<cgp-app-card [titleText]="resourced ? ' *** Re-sourced ECM Information Displayed (Read Only) *** ' : 'View/Update ECM'"
   showFullScreenToggle="true" [showBackButton]="true" [onBackButtonClicked]="onBackButtonClicked">
   <div *ngIf="hasLoaded" class="full-height flex-stretch flex-column">
      <div class="half-height flex-stretch flex-column">
         <data-table #tools [data]="data" [columns]="columns" (lazyLoad)="onLazyLoad($event)" [lazy]="true"
            [paging]="true" [emptySelection]="true" [pageSize]="pageOptions.size" [totalRecords]="total"
            [loading]="loading" [filterable]="true" (edit)="updateTool($event)" (select)="onSelect($event)" [filterColumnDisplay]="false">
            <ng-container actionStart>
               <button mat-button (keypress)="onEcmNecReportsClick()" (click)="onEcmNecReportsClick()">Nec
                  Reports</button>
               <mat-divider vertical class="action-bar-vertical-divider"></mat-divider>
               <button mat-button (keypress)="onEcmReportsClick()" (click)="onEcmReportsClick()">ECM Reports</button>
               <mat-divider vertical class="action-bar-vertical-divider"></mat-divider>
               <button mat-button (keypress)="onToolPartRelationshipClick()"
                  (click)="onToolPartRelationshipClick()">Edit
                  Tool/Part Relationship</button>
               <mat-divider vertical class="action-bar-vertical-divider"></mat-divider>
               <button mat-button (keypress)="onEcmPartsClick()" (click)="onEcmPartsClick()">Parts</button>
               <mat-divider vertical class="action-bar-vertical-divider"></mat-divider>
               <button mat-button [disabled]="this.resourced" (keypress)="onEcmPartsUploadClick()"
                  (click)="onEcmPartsUploadClick()">Upload Parts from a File</button>
            </ng-container>
            <ng-container actionEnd>
               <button mat-button (keydown.enter)="onBackButtonClicked()" (click)="onBackButtonClicked()"> Close
               </button>
            </ng-container>
         </data-table>
      </div>
      <div class="half-height flex-stretch flex-column">
         <ecm-tool-change [resourced]="this.resourced" [selectedEcmTool$]="selectedEcmTool$"></ecm-tool-change>
      </div>
   </div>
</cgp-app-card>
